"use strict";

exports.__esModule = true;
exports.SIZE = void 0;
var SIZE = {
  small: 'small',
  medium: 'medium',
  large: 'large'
};
exports.SIZE = SIZE;